import React from 'react';
import {Modal} from "react-bootstrap";
import ResponsiveComponent from "../../../../components/Common/ResponsiveComponent";
import {ReactComponent as LeftIco} from "../../../../../images/icons/arrow-left.svg";
import {useTranslation} from "react-i18next";

interface Props {
    onClick: () => void | Promise<void>;
    title: string;
    ariaLabelledBy: string;
}

const MenuProductModalHeader = ({onClick, title, ariaLabelledBy}: Props) => {
    const {t} = useTranslation();

    const handleOnBackClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        onClick();
    }

    return (
        <Modal.Header>
            <ResponsiveComponent
                small={
                    <a className="back-icon" href="#" onClick={handleOnBackClick}>
                        <LeftIco className="icon" aria-label={t("common.action.back")}/>
                    </a>
                }
                large={<></>}
                breakpoint={832}
            />
            <Modal.Title id={ariaLabelledBy}>
                {title}
            </Modal.Title>
            <ResponsiveComponent
                small={<></>}
                large={
                    <button onClick={onClick} className="btn-close" data-bs-dismiss="modal"
                            aria-label={t("common.action.close")}/>
                }
                breakpoint={832}
            />
        </Modal.Header>
    )
}

export default MenuProductModalHeader;